import React, { useState } from 'react'
import { CardBody, Col, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import classnames from 'classnames';
import SpeedAndConsumptionDisplay from './SpeedAndConsumptionDisplay';

const MainEngineSpeedAndConsumption = ({
    subtab
}: any) => {
    const [activeSettingsTab, setActiveSettingsTab] = useState(1);

    const toggle = (tab: number) => {
        setActiveSettingsTab(tab);
    };

    // If subtab is directly the array from your console output
    const getWeatherTabStatus = (weatherType: any) => {
        // Assuming subtab is the array directly
        const mainEngineTab = subtab?.find((tab: any) =>
            tab.form_name === "Main Engine Speed & Consumption"
        );

        if (mainEngineTab && mainEngineTab.nested_tabs) {
            const weatherTab = mainEngineTab.nested_tabs.find((nestedTab: any) =>
                nestedTab.form_name === weatherType
            );
            return weatherTab ? weatherTab.status : null;
        }
        return null;
    };

    const renderStatusIcon = (status: string) => {
        if (status === 'completed') {
            return <i className="bx bx-check-double text-success me-2" />;
        } else if (status === 'pending') {
            return <i className="mdi mdi-clock-edit-outline text-warning me-2" />;
        } else {
            return null;
        }
    };

    return (
        <React.Fragment>
            <CardBody className='pb-0 pt-0 mt-0'>
                <Col lg='6'>
                    <Nav tabs className='nav-tabs-custom nav-justified'>
                        <NavItem>
                            <NavLink
                                style={{ cursor: 'pointer' }}
                                className={classnames({ active: activeSettingsTab === 1 })}
                                onClick={() => toggle(1)}
                            >
                                {renderStatusIcon(getWeatherTabStatus("Fair Weather"))}
                                Fair Weather
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                style={{ cursor: 'pointer' }}
                                className={classnames({ active: activeSettingsTab === 2 })}
                                onClick={() => toggle(2)}
                            >
                                {renderStatusIcon(getWeatherTabStatus("All Weather"))}
                                All Weather
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Col>
            </CardBody>
            <TabContent activeTab={activeSettingsTab} className='p-3 text-muted'>
                <TabPane tabId={1} className='m-0'>
                    <SpeedAndConsumptionDisplay
                        weatherCondtion='Fair'
                    />
                </TabPane>
                <TabPane tabId={2} className='m-0'>
                    <SpeedAndConsumptionDisplay
                        weatherCondtion='All'
                    />
                </TabPane>
            </TabContent>
        </React.Fragment>
    )
}

export default MainEngineSpeedAndConsumption